// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoutineExamsModule-module__font-s-10___DROz_ {
  font-size: 10px !important;
}

.RoutineExamsModule-module__font-s-12___w0wXo {
  font-size: 12px !important;
}

.RoutineExamsModule-module__font-s-13___d_wEV {
  font-size: 13px !important;
}

.RoutineExamsModule-module__font-s-14___FKp6Q {
  font-size: 14px !important;
}

.RoutineExamsModule-module__font-s-15___zmtOg {
  font-size: 15px !important;
}

.RoutineExamsModule-module__font-s-16___wo_Np {
  font-size: 16px !important;
}

.RoutineExamsModule-module__font-s-18___Ls_l2 {
  font-size: 18px !important;
}

.RoutineExamsModule-module__font-s-20___zAZrl {
  font-size: 20px !important;
}

.RoutineExamsModule-module__font-s-22___dNTEk {
  font-size: 22px !important;
}

.RoutineExamsModule-module__font-s-28___BbOdp {
  font-size: 28px !important;
}

.RoutineExamsModule-module__font-w-400___oNR_G {
  font-weight: 400 !important;
}

.RoutineExamsModule-module__font-w-500___yqNKo {
  font-weight: 500 !important;
}

.RoutineExamsModule-module__font-w-600___psZAK {
  font-weight: 600 !important;
}

.RoutineExamsModule-module__font-w-700___zTNgj {
  font-weight: 700 !important;
}

.RoutineExamsModule-module__p-5___i12g9 {
  padding: 5px !important;
}

.RoutineExamsModule-module__p-12___x0yRw {
  padding: 12px !important;
}

.RoutineExamsModule-module__p-16___SOnjW {
  padding: 16px !important;
}

.RoutineExamsModule-module__p-30___JNtFv {
  padding: 30px !important;
}

.RoutineExamsModule-module__p-b-0___JVlBn {
  padding-bottom: 0 !important;
}

.RoutineExamsModule-module__p-b-5___hhK9X {
  padding-bottom: 5px !important;
}

.RoutineExamsModule-module__p-b-10___Q8jij {
  padding-bottom: 10px !important;
}

.RoutineExamsModule-module__p-b-12___ueSEg {
  padding-bottom: 12px !important;
}

.RoutineExamsModule-module__p-b-16___R7Gv_ {
  padding-bottom: 16px !important;
}

.RoutineExamsModule-module__p-b-18___nnE3k {
  padding-bottom: 18px !important;
}

.RoutineExamsModule-module__p-b-20___Hg2d5 {
  padding-bottom: 20px !important;
}

.RoutineExamsModule-module__p-b-25___VhgT4 {
  padding-bottom: 25px !important;
}

.RoutineExamsModule-module__p-b-30___LFiHV {
  padding-bottom: 30px !important;
}

.RoutineExamsModule-module__p-b-50___rhNO_ {
  padding-bottom: 50px !important;
}

.RoutineExamsModule-module__p-t-0___wHfkA {
  padding-top: 0 !important;
}

.RoutineExamsModule-module__p-t-12___zPMFD {
  padding-top: 12px !important;
}

.RoutineExamsModule-module__p-t-16___rNp1w {
  padding-top: 16px !important;
}

.RoutineExamsModule-module__p-t-18___XgEPu {
  padding-top: 18px !important;
}

.RoutineExamsModule-module__p-t-20___qpR7_ {
  padding-top: 20px !important;
}

.RoutineExamsModule-module__p-t-30___t3VHV {
  padding-top: 30px !important;
}

.RoutineExamsModule-module__p-t-40___DXG4H {
  padding-top: 40px !important;
}

.RoutineExamsModule-module__p-t-50___Yujxk {
  padding-top: 50px !important;
}

.RoutineExamsModule-module__p-l-20___KPtaZ {
  padding-left: 20px !important;
}

.RoutineExamsModule-module__p-l-30___Daleq {
  padding-left: 30px !important;
}

.RoutineExamsModule-module__p-l-40___c6ZpF {
  padding-left: 40px !important;
}

.RoutineExamsModule-module__p-r-16___HSBHa {
  padding-right: 16px !important;
}

.RoutineExamsModule-module__p-r-20___ZhZJk {
  padding-right: 20px !important;
}

.RoutineExamsModule-module__p-r-30___vPzZz {
  padding-right: 30px !important;
}

.RoutineExamsModule-module__p-r-50___bjTl0 {
  padding-right: 50px !important;
}

.RoutineExamsModule-module__p-r-60___gQvnI {
  padding-right: 60px !important;
}

.RoutineExamsModule-module__m-b-1___UNx1C {
  margin-bottom: 1px !important;
}

.RoutineExamsModule-module__m-b-2___Xq1VY {
  margin-bottom: 2px !important;
}

.RoutineExamsModule-module__m-b-6___sYkVh {
  margin-bottom: 6px !important;
}

.RoutineExamsModule-module__m-b-8___XMMWA {
  margin-bottom: 8px !important;
}

.RoutineExamsModule-module__m-b-10___KN1B4 {
  margin-bottom: 10px !important;
}

.RoutineExamsModule-module__m-b-14___lvGl3 {
  margin-bottom: 14px !important;
}

.RoutineExamsModule-module__m-b-16___cKoWr {
  margin-bottom: 16px !important;
}

.RoutineExamsModule-module__m-b-20___zIwCO {
  margin-bottom: 20px !important;
}

.RoutineExamsModule-module__m-b-22___d8A6B {
  margin-bottom: 22px !important;
}

.RoutineExamsModule-module__m-b-24___x2krg {
  margin-bottom: 24px !important;
}

.RoutineExamsModule-module__m-b-30___ffMLL {
  margin-bottom: 30px !important;
}

.RoutineExamsModule-module__m-b-32___Kezaw {
  margin-bottom: 32px !important;
}

.RoutineExamsModule-module__m-b-40___uL76q {
  margin-bottom: 40px !important;
}

.RoutineExamsModule-module__m-t-2___JFKuw {
  margin-top: 2px !important;
}

.RoutineExamsModule-module__m-t-3___aL5xF {
  margin-top: 3px !important;
}

.RoutineExamsModule-module__m-t-4___HGzQH {
  margin-top: 4px !important;
}

.RoutineExamsModule-module__m-t-5___Hw2M0 {
  margin-top: 5px !important;
}

.RoutineExamsModule-module__m-t-8___ofKrw {
  margin-top: 8px !important;
}

.RoutineExamsModule-module__m-t-10___Hgzrd {
  margin-top: 10px !important;
}

.RoutineExamsModule-module__m-t-15___rOM4Z {
  margin-top: 15px !important;
}

.RoutineExamsModule-module__m-t-16___AaH5w {
  margin-top: 16px !important;
}

.RoutineExamsModule-module__m-t-20___LUBe_ {
  margin-top: 20px !important;
}

.RoutineExamsModule-module__m-t-22___q95VQ {
  margin-top: 22px !important;
}

.RoutineExamsModule-module__m-t-30___LlJ2F {
  margin-top: 30px !important;
}

.RoutineExamsModule-module__m-t-32___vHBc0 {
  margin-top: 32px !important;
}

.RoutineExamsModule-module__m-l-auto___Ju1uR {
  margin-left: auto !important;
}

.RoutineExamsModule-module__m-l-4___OTvuS {
  margin-left: 4px !important;
}

.RoutineExamsModule-module__m-l-5___VGfUp {
  margin-left: 5px !important;
}

.RoutineExamsModule-module__m-l-6____YObS {
  margin-left: 6px !important;
}

.RoutineExamsModule-module__m-l-8___vOY2Q {
  margin-left: 8px !important;
}

.RoutineExamsModule-module__m-l-10____UK_P {
  margin-left: 10px !important;
}

.RoutineExamsModule-module__m-l-16___399y7 {
  margin-left: 16px !important;
}

.RoutineExamsModule-module__m-l-20___NVjhE {
  margin-left: 20px !important;
}

.RoutineExamsModule-module__m-l-24___w3DzK {
  margin-left: 24px !important;
}

.RoutineExamsModule-module__m-l-30___wn1Zq {
  margin-left: 30px !important;
}

.RoutineExamsModule-module__m-l-35___XEKBV {
  margin-left: 35px !important;
}

.RoutineExamsModule-module__m-l-40___DrVJ4 {
  margin-left: 40px !important;
}

.RoutineExamsModule-module__m-r-8___vsAjW {
  margin-right: 8px !important;
}

.RoutineExamsModule-module__m-r-10___Qs6RR {
  margin-right: 10px !important;
}

.RoutineExamsModule-module__m-r-16___I59Ct {
  margin-right: 16px !important;
}

.RoutineExamsModule-module__m-r-20___Ze01E {
  margin-right: 20px !important;
}

.RoutineExamsModule-module__m-r-24___dcT3z {
  margin-right: 24px !important;
}

.RoutineExamsModule-module__m-r-30___mmX33 {
  margin-right: 30px !important;
}

.RoutineExamsModule-module__m-r-40___dvIA_ {
  margin-right: 40px !important;
}

.RoutineExamsModule-module__border-r-3___VGRUp {
  border-radius: 3px !important;
}

.RoutineExamsModule-module__border-r-4___oTFwQ {
  border-radius: 4px !important;
}

.RoutineExamsModule-module__border-r-6___vhWb4 {
  border-radius: 6px !important;
}

.RoutineExamsModule-module__border-r-10___ch2B2 {
  border-radius: 10px !important;
}

.RoutineExamsModule-module__border-r-12___rAlPJ {
  border-radius: 12px !important;
}

.RoutineExamsModule-module__border-r-16___DJWoO {
  border-radius: 16px !important;
}

.RoutineExamsModule-module__border-r-50___kkbob {
  border-radius: 50% !important;
}

.RoutineExamsModule-module__primary-border___RcnoH {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.RoutineExamsModule-module__primary-border-b___dTdi2 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.RoutineExamsModule-module__primary-border-t___OOVm1 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.RoutineExamsModule-module__primary-border-l___mYQ54 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.RoutineExamsModule-module__primary-border-r___i0nvu {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.RoutineExamsModule-module__secondary-border___JVJrz {
  border: 1px solid #637768;
}

.RoutineExamsModule-module__secondary-border-b___tzyNa {
  border-bottom: 1px solid #637768;
}

.RoutineExamsModule-module__secondary-border-t___TZYMK {
  border-top: 1px solid #637768;
}

.RoutineExamsModule-module__secondary-border-l___LosC8 {
  border-left: 1px solid #637768;
}

.RoutineExamsModule-module__secondary-border-r____IFPz {
  border-right: 1px solid #637768;
}

.RoutineExamsModule-module__gap-0___YDxmE {
  gap: 0 !important;
}

.RoutineExamsModule-module__gap-2___lxSnR {
  gap: 2px !important;
}

.RoutineExamsModule-module__gap-4___tkXNd {
  gap: 4px !important;
}

.RoutineExamsModule-module__gap-5___yVrYl {
  gap: 5px !important;
}

.RoutineExamsModule-module__gap-6___XvRZu {
  gap: 6px !important;
}

.RoutineExamsModule-module__gap-8___S8zAC {
  gap: 8px !important;
}

.RoutineExamsModule-module__gap-10___WF9kN {
  gap: 10px !important;
}

.RoutineExamsModule-module__gap-12___AOLE0 {
  gap: 12px !important;
}

.RoutineExamsModule-module__gap-14___NYnro {
  gap: 14px !important;
}

.RoutineExamsModule-module__gap-16___sHfJY {
  gap: 16px !important;
}

.RoutineExamsModule-module__gap-18___McpbM {
  gap: 18px !important;
}

.RoutineExamsModule-module__gap-20___hWDTj {
  gap: 20px !important;
}

.RoutineExamsModule-module__gap-24___kBPoc {
  gap: 24px !important;
}

.RoutineExamsModule-module__gap-26___uLCJl {
  gap: 26px !important;
}

.RoutineExamsModule-module__gap-30___FtpSb {
  gap: 30px !important;
}

.RoutineExamsModule-module__gap-32___udr3Y {
  gap: 32px !important;
}

.RoutineExamsModule-module__gap-40___veD8m {
  gap: 40px !important;
}

.RoutineExamsModule-module__gap-50___EgPE8 {
  gap: 50px !important;
}

.RoutineExamsModule-module__flex-1___vsx1G {
  flex: 1;
}

.RoutineExamsModule-module__flex-none___L_S7g {
  flex: none !important;
}

.RoutineExamsModule-module__flex-column___w6N8J {
  display: flex;
  flex-direction: column !important;
}

.RoutineExamsModule-module__flex-row___lVcYX {
  display: flex;
  flex-direction: row !important;
}

.RoutineExamsModule-module__vertically-centered___mjtik {
  display: flex;
  align-items: center !important;
}

.RoutineExamsModule-module__horizontally-centered___O1Hx6 {
  display: flex;
  justify-content: center !important;
}

.RoutineExamsModule-module__horizontally-end___P_dMB {
  display: flex;
  justify-content: end !important;
}

.RoutineExamsModule-module__vertically-start___EF41J {
  display: flex;
  align-items: start !important;
}

.RoutineExamsModule-module__space-between___ogPx9 {
  display: flex;
  justify-content: space-between !important;
}

.RoutineExamsModule-module__flex-wrap___QlAZo {
  flex-wrap: wrap !important;
}

.RoutineExamsModule-module__height-100___sr0b2 {
  height: 100%;
}

.RoutineExamsModule-module__width-50___jcpoJ {
  width: 50% !important;
}

.RoutineExamsModule-module__width-100___KHA35 {
  width: 100%;
}

.RoutineExamsModule-module__cursor-pointer___iQKip {
  cursor: pointer;
}

.RoutineExamsModule-module__cursor-not-allowed___RR6jX {
  cursor: not-allowed !important;
}

.RoutineExamsModule-module__absolute-centered___iVdXx {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.RoutineExamsModule-module__absolute___RbHm3 {
  position: absolute;
}

.RoutineExamsModule-module__relative___HiD4R {
  position: relative;
}

.RoutineExamsModule-module__fixed___XA0q8 {
  position: fixed;
}

.RoutineExamsModule-module__visible___Yh9hk {
  opacity: 1;
}

.RoutineExamsModule-module__invisible___SCx4q {
  opacity: 0;
}

.RoutineExamsModule-module__col-90___ubWfP {
  width: 90% !important;
}

.RoutineExamsModule-module__col-auto___izseJ {
  width: auto !important;
}

.RoutineExamsModule-module__medical-tabs___eVUzX {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.RoutineExamsModule-module__medical-table-new___H5Dx3 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RoutineExamsModule-module__medical-table-new___H5Dx3:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RoutineExamsModule-module__medical-table-new___H5Dx3::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RoutineExamsModule-module__medical-table-new___H5Dx3::-webkit-scrollbar-track {
  display: none;
}
.RoutineExamsModule-module__medical-table-new___H5Dx3.RoutineExamsModule-module__no-pagination___RSvGI {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RoutineExamsModule-module__medical-table-new___H5Dx3.RoutineExamsModule-module__no-pagination___RSvGI:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RoutineExamsModule-module__medical-table-new___H5Dx3.RoutineExamsModule-module__no-pagination___RSvGI::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RoutineExamsModule-module__medical-table-new___H5Dx3.RoutineExamsModule-module__no-pagination___RSvGI::-webkit-scrollbar-track {
  display: none;
}

.RoutineExamsModule-module__medical-table-empty___cRf2I {
  padding: 14px 40px !important;
}

.RoutineExamsModule-module__icon-btn___bcnHk {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.RoutineExamsModule-module__search-icon___Zt4C8 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.RoutineExamsModule-module__disable-select___YuaYC {
  user-select: none;
}

.RoutineExamsModule-module__break-word___ozzq3 {
  word-break: break-word;
}

.RoutineExamsModule-module__popup-clear-btn___rToiT {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.RoutineExamsModule-module__scroll-m-b-20___ITJ_F {
  scroll-margin-bottom: 20px;
}

.RoutineExamsModule-module__container___ykoq6 {
  color: #375844;
  margin-bottom: -6px;
}
.RoutineExamsModule-module__container___ykoq6 .RoutineExamsModule-module__instructions___MSvyn {
  width: 85%;
}
.RoutineExamsModule-module__container___ykoq6 .RoutineExamsModule-module__warning___v5pKp {
  color: #ffa727;
  scroll-margin: 10px;
}
.RoutineExamsModule-module__container___ykoq6 .RoutineExamsModule-module__button___tZgOH {
  padding: 5px !important;
  width: 200px;
}
.RoutineExamsModule-module__container___ykoq6 .RoutineExamsModule-module__button___tZgOH > span {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/RoutineExamsModule/RoutineExamsModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,UAAA;AA8pBJ;AA3pBE;EACE,cAAA;EACA,mBAAA;AA6pBJ;AA1pBE;EACE,uBAAA;EACA,YAAA;AA4pBJ;AA1pBI;EACE,eAAA;AA4pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  margin-bottom: -6px;\n\n  .instructions {\n    width: 85%;\n  }\n\n  .warning {\n    color: get-color(orange, medium);\n    scroll-margin: 10px;\n  }\n\n  .button {\n    padding: 5px !important;\n    width: 200px;\n\n    & > span {\n      font-size: 14px;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `RoutineExamsModule-module__font-s-10___DROz_`,
	"fontS12": `RoutineExamsModule-module__font-s-12___w0wXo`,
	"fontS13": `RoutineExamsModule-module__font-s-13___d_wEV`,
	"fontS14": `RoutineExamsModule-module__font-s-14___FKp6Q`,
	"fontS15": `RoutineExamsModule-module__font-s-15___zmtOg`,
	"fontS16": `RoutineExamsModule-module__font-s-16___wo_Np`,
	"fontS18": `RoutineExamsModule-module__font-s-18___Ls_l2`,
	"fontS20": `RoutineExamsModule-module__font-s-20___zAZrl`,
	"fontS22": `RoutineExamsModule-module__font-s-22___dNTEk`,
	"fontS28": `RoutineExamsModule-module__font-s-28___BbOdp`,
	"fontW400": `RoutineExamsModule-module__font-w-400___oNR_G`,
	"fontW500": `RoutineExamsModule-module__font-w-500___yqNKo`,
	"fontW600": `RoutineExamsModule-module__font-w-600___psZAK`,
	"fontW700": `RoutineExamsModule-module__font-w-700___zTNgj`,
	"p5": `RoutineExamsModule-module__p-5___i12g9`,
	"p12": `RoutineExamsModule-module__p-12___x0yRw`,
	"p16": `RoutineExamsModule-module__p-16___SOnjW`,
	"p30": `RoutineExamsModule-module__p-30___JNtFv`,
	"pB0": `RoutineExamsModule-module__p-b-0___JVlBn`,
	"pB5": `RoutineExamsModule-module__p-b-5___hhK9X`,
	"pB10": `RoutineExamsModule-module__p-b-10___Q8jij`,
	"pB12": `RoutineExamsModule-module__p-b-12___ueSEg`,
	"pB16": `RoutineExamsModule-module__p-b-16___R7Gv_`,
	"pB18": `RoutineExamsModule-module__p-b-18___nnE3k`,
	"pB20": `RoutineExamsModule-module__p-b-20___Hg2d5`,
	"pB25": `RoutineExamsModule-module__p-b-25___VhgT4`,
	"pB30": `RoutineExamsModule-module__p-b-30___LFiHV`,
	"pB50": `RoutineExamsModule-module__p-b-50___rhNO_`,
	"pT0": `RoutineExamsModule-module__p-t-0___wHfkA`,
	"pT12": `RoutineExamsModule-module__p-t-12___zPMFD`,
	"pT16": `RoutineExamsModule-module__p-t-16___rNp1w`,
	"pT18": `RoutineExamsModule-module__p-t-18___XgEPu`,
	"pT20": `RoutineExamsModule-module__p-t-20___qpR7_`,
	"pT30": `RoutineExamsModule-module__p-t-30___t3VHV`,
	"pT40": `RoutineExamsModule-module__p-t-40___DXG4H`,
	"pT50": `RoutineExamsModule-module__p-t-50___Yujxk`,
	"pL20": `RoutineExamsModule-module__p-l-20___KPtaZ`,
	"pL30": `RoutineExamsModule-module__p-l-30___Daleq`,
	"pL40": `RoutineExamsModule-module__p-l-40___c6ZpF`,
	"pR16": `RoutineExamsModule-module__p-r-16___HSBHa`,
	"pR20": `RoutineExamsModule-module__p-r-20___ZhZJk`,
	"pR30": `RoutineExamsModule-module__p-r-30___vPzZz`,
	"pR50": `RoutineExamsModule-module__p-r-50___bjTl0`,
	"pR60": `RoutineExamsModule-module__p-r-60___gQvnI`,
	"mB1": `RoutineExamsModule-module__m-b-1___UNx1C`,
	"mB2": `RoutineExamsModule-module__m-b-2___Xq1VY`,
	"mB6": `RoutineExamsModule-module__m-b-6___sYkVh`,
	"mB8": `RoutineExamsModule-module__m-b-8___XMMWA`,
	"mB10": `RoutineExamsModule-module__m-b-10___KN1B4`,
	"mB14": `RoutineExamsModule-module__m-b-14___lvGl3`,
	"mB16": `RoutineExamsModule-module__m-b-16___cKoWr`,
	"mB20": `RoutineExamsModule-module__m-b-20___zIwCO`,
	"mB22": `RoutineExamsModule-module__m-b-22___d8A6B`,
	"mB24": `RoutineExamsModule-module__m-b-24___x2krg`,
	"mB30": `RoutineExamsModule-module__m-b-30___ffMLL`,
	"mB32": `RoutineExamsModule-module__m-b-32___Kezaw`,
	"mB40": `RoutineExamsModule-module__m-b-40___uL76q`,
	"mT2": `RoutineExamsModule-module__m-t-2___JFKuw`,
	"mT3": `RoutineExamsModule-module__m-t-3___aL5xF`,
	"mT4": `RoutineExamsModule-module__m-t-4___HGzQH`,
	"mT5": `RoutineExamsModule-module__m-t-5___Hw2M0`,
	"mT8": `RoutineExamsModule-module__m-t-8___ofKrw`,
	"mT10": `RoutineExamsModule-module__m-t-10___Hgzrd`,
	"mT15": `RoutineExamsModule-module__m-t-15___rOM4Z`,
	"mT16": `RoutineExamsModule-module__m-t-16___AaH5w`,
	"mT20": `RoutineExamsModule-module__m-t-20___LUBe_`,
	"mT22": `RoutineExamsModule-module__m-t-22___q95VQ`,
	"mT30": `RoutineExamsModule-module__m-t-30___LlJ2F`,
	"mT32": `RoutineExamsModule-module__m-t-32___vHBc0`,
	"mLAuto": `RoutineExamsModule-module__m-l-auto___Ju1uR`,
	"mL4": `RoutineExamsModule-module__m-l-4___OTvuS`,
	"mL5": `RoutineExamsModule-module__m-l-5___VGfUp`,
	"mL6": `RoutineExamsModule-module__m-l-6____YObS`,
	"mL8": `RoutineExamsModule-module__m-l-8___vOY2Q`,
	"mL10": `RoutineExamsModule-module__m-l-10____UK_P`,
	"mL16": `RoutineExamsModule-module__m-l-16___399y7`,
	"mL20": `RoutineExamsModule-module__m-l-20___NVjhE`,
	"mL24": `RoutineExamsModule-module__m-l-24___w3DzK`,
	"mL30": `RoutineExamsModule-module__m-l-30___wn1Zq`,
	"mL35": `RoutineExamsModule-module__m-l-35___XEKBV`,
	"mL40": `RoutineExamsModule-module__m-l-40___DrVJ4`,
	"mR8": `RoutineExamsModule-module__m-r-8___vsAjW`,
	"mR10": `RoutineExamsModule-module__m-r-10___Qs6RR`,
	"mR16": `RoutineExamsModule-module__m-r-16___I59Ct`,
	"mR20": `RoutineExamsModule-module__m-r-20___Ze01E`,
	"mR24": `RoutineExamsModule-module__m-r-24___dcT3z`,
	"mR30": `RoutineExamsModule-module__m-r-30___mmX33`,
	"mR40": `RoutineExamsModule-module__m-r-40___dvIA_`,
	"borderR3": `RoutineExamsModule-module__border-r-3___VGRUp`,
	"borderR4": `RoutineExamsModule-module__border-r-4___oTFwQ`,
	"borderR6": `RoutineExamsModule-module__border-r-6___vhWb4`,
	"borderR10": `RoutineExamsModule-module__border-r-10___ch2B2`,
	"borderR12": `RoutineExamsModule-module__border-r-12___rAlPJ`,
	"borderR16": `RoutineExamsModule-module__border-r-16___DJWoO`,
	"borderR50": `RoutineExamsModule-module__border-r-50___kkbob`,
	"primaryBorder": `RoutineExamsModule-module__primary-border___RcnoH`,
	"primaryBorderB": `RoutineExamsModule-module__primary-border-b___dTdi2`,
	"primaryBorderT": `RoutineExamsModule-module__primary-border-t___OOVm1`,
	"primaryBorderL": `RoutineExamsModule-module__primary-border-l___mYQ54`,
	"primaryBorderR": `RoutineExamsModule-module__primary-border-r___i0nvu`,
	"secondaryBorder": `RoutineExamsModule-module__secondary-border___JVJrz`,
	"secondaryBorderB": `RoutineExamsModule-module__secondary-border-b___tzyNa`,
	"secondaryBorderT": `RoutineExamsModule-module__secondary-border-t___TZYMK`,
	"secondaryBorderL": `RoutineExamsModule-module__secondary-border-l___LosC8`,
	"secondaryBorderR": `RoutineExamsModule-module__secondary-border-r____IFPz`,
	"gap0": `RoutineExamsModule-module__gap-0___YDxmE`,
	"gap2": `RoutineExamsModule-module__gap-2___lxSnR`,
	"gap4": `RoutineExamsModule-module__gap-4___tkXNd`,
	"gap5": `RoutineExamsModule-module__gap-5___yVrYl`,
	"gap6": `RoutineExamsModule-module__gap-6___XvRZu`,
	"gap8": `RoutineExamsModule-module__gap-8___S8zAC`,
	"gap10": `RoutineExamsModule-module__gap-10___WF9kN`,
	"gap12": `RoutineExamsModule-module__gap-12___AOLE0`,
	"gap14": `RoutineExamsModule-module__gap-14___NYnro`,
	"gap16": `RoutineExamsModule-module__gap-16___sHfJY`,
	"gap18": `RoutineExamsModule-module__gap-18___McpbM`,
	"gap20": `RoutineExamsModule-module__gap-20___hWDTj`,
	"gap24": `RoutineExamsModule-module__gap-24___kBPoc`,
	"gap26": `RoutineExamsModule-module__gap-26___uLCJl`,
	"gap30": `RoutineExamsModule-module__gap-30___FtpSb`,
	"gap32": `RoutineExamsModule-module__gap-32___udr3Y`,
	"gap40": `RoutineExamsModule-module__gap-40___veD8m`,
	"gap50": `RoutineExamsModule-module__gap-50___EgPE8`,
	"flex1": `RoutineExamsModule-module__flex-1___vsx1G`,
	"flexNone": `RoutineExamsModule-module__flex-none___L_S7g`,
	"flexColumn": `RoutineExamsModule-module__flex-column___w6N8J`,
	"flexRow": `RoutineExamsModule-module__flex-row___lVcYX`,
	"verticallyCentered": `RoutineExamsModule-module__vertically-centered___mjtik`,
	"horizontallyCentered": `RoutineExamsModule-module__horizontally-centered___O1Hx6`,
	"horizontallyEnd": `RoutineExamsModule-module__horizontally-end___P_dMB`,
	"verticallyStart": `RoutineExamsModule-module__vertically-start___EF41J`,
	"spaceBetween": `RoutineExamsModule-module__space-between___ogPx9`,
	"flexWrap": `RoutineExamsModule-module__flex-wrap___QlAZo`,
	"height100": `RoutineExamsModule-module__height-100___sr0b2`,
	"width50": `RoutineExamsModule-module__width-50___jcpoJ`,
	"width100": `RoutineExamsModule-module__width-100___KHA35`,
	"cursorPointer": `RoutineExamsModule-module__cursor-pointer___iQKip`,
	"cursorNotAllowed": `RoutineExamsModule-module__cursor-not-allowed___RR6jX`,
	"absoluteCentered": `RoutineExamsModule-module__absolute-centered___iVdXx`,
	"absolute": `RoutineExamsModule-module__absolute___RbHm3`,
	"relative": `RoutineExamsModule-module__relative___HiD4R`,
	"fixed": `RoutineExamsModule-module__fixed___XA0q8`,
	"visible": `RoutineExamsModule-module__visible___Yh9hk`,
	"invisible": `RoutineExamsModule-module__invisible___SCx4q`,
	"col90": `RoutineExamsModule-module__col-90___ubWfP`,
	"colAuto": `RoutineExamsModule-module__col-auto___izseJ`,
	"medicalTabs": `RoutineExamsModule-module__medical-tabs___eVUzX`,
	"medicalTableNew": `RoutineExamsModule-module__medical-table-new___H5Dx3`,
	"noPagination": `RoutineExamsModule-module__no-pagination___RSvGI`,
	"medicalTableEmpty": `RoutineExamsModule-module__medical-table-empty___cRf2I`,
	"iconBtn": `RoutineExamsModule-module__icon-btn___bcnHk`,
	"searchIcon": `RoutineExamsModule-module__search-icon___Zt4C8`,
	"disableSelect": `RoutineExamsModule-module__disable-select___YuaYC`,
	"breakWord": `RoutineExamsModule-module__break-word___ozzq3`,
	"popupClearBtn": `RoutineExamsModule-module__popup-clear-btn___rToiT`,
	"scrollMB20": `RoutineExamsModule-module__scroll-m-b-20___ITJ_F`,
	"container": `RoutineExamsModule-module__container___ykoq6`,
	"instructions": `RoutineExamsModule-module__instructions___MSvyn`,
	"warning": `RoutineExamsModule-module__warning___v5pKp`,
	"button": `RoutineExamsModule-module__button___tZgOH`
};
module.exports = ___CSS_LOADER_EXPORT___;
